import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef } from 'react';
import { EmbedContext, defaultEmbedContextValue } from './Context';
import { embedContextReducer } from './reducer';
import { useEditableTemplateBoard, editableTemplatesConfig } from '../hooks/useEditableTemplateBoard';
import { jsx as _jsx } from "react/jsx-runtime";
var config = {
  editableTemplateBoard: {
    boardContainerConfig: {
      boardContainerWidth: '100%',
      boardContainerHeight: '100%',
      boardContainerTestId: 'editable-template-board-container',
      initialMode: 'inline'
    },
    iframeConfig: {
      preproductBaseUrl: '/pre-products/editable-templates/template',
      testId: 'editable-board-preview-frame',
      title: 'Editable board preview frame'
    }
  }
};
export var PreproductContextProvider = function PreproductContextProvider(_ref) {
  var configType = _ref.configType,
      templateKey = _ref.templateKey,
      customConfig = _ref.customConfig,
      children = _ref.children;
  var iframeRef = useRef(null);

  var _useEditableTemplateB = useEditableTemplateBoard(templateKey !== null && templateKey !== void 0 ? templateKey : '', editableTemplatesConfig),
      isEditableTemplatesExperiment = _useEditableTemplateB.isEditableTemplatesExperiment,
      isEditableTemplateBoardActive = _useEditableTemplateB.isEditableTemplateBoardActive,
      editableTemplatePreview = _useEditableTemplateB.editableTemplatePreview;

  var _React$useReducer = React.useReducer(embedContextReducer, _objectSpread(_objectSpread(_objectSpread({}, defaultEmbedContextValue), config[configType]), customConfig)),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return /*#__PURE__*/_jsx(EmbedContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      iframeState: _objectSpread(_objectSpread({}, state.iframeState), {}, {
        iframeRef: iframeRef
      }),
      boardContainerState: _objectSpread(_objectSpread({}, state.boardContainerState), {}, {
        editableTemplates: {
          isEditableTemplatesExperiment: isEditableTemplatesExperiment,
          isEditableTemplateBoardActive: isEditableTemplateBoardActive,
          editableTemplatePreview: editableTemplatePreview,
          templateKey: templateKey !== null && templateKey !== void 0 ? templateKey : ''
        }
      }),
      dispatch: dispatch
    }),
    children: children
  });
};